import type { FC, PropsWithChildren } from 'react'

import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import LogoCarouselBase, * as LogoCarousel from '@segment/matcha/recipes/LogoCarousel'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import { carouselLogos } from '@segment/templates/LogoCarousel/data'

const copy = {
  heading: `You’re in great company`,
  logosHeading: `Join the 25,000+ companies using the Segment platform`,
}

const logos = [
  carouselLogos.TOGGLE,
  carouselLogos.GOOD_EGGS,
  carouselLogos.ALLERGAN,
  carouselLogos.DOMINOS,
  carouselLogos.APP_DYNAMICS,
  carouselLogos.TAXFIX,
  carouselLogos.INTEGRA_BEAUTY,
  carouselLogos.CLEAN_CHOICE_ENERGY,
  carouselLogos.VISTA,
]

const LogoCarouselComponent: FC<PropsWithChildren<unknown>> = () => {
  return (
    <StyledSectionBase variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading variant="h2" tag="h3">
            {copy.heading}
          </CopyText.Heading>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <LogoCarouselBase>
          <LogoCarousel.Heading>{copy.logosHeading}</LogoCarousel.Heading>
          <LogoCarousel.LogoTrack icons={logos} />
        </LogoCarouselBase>
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 10px;
    row-gap: 24px;
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      row-gap: 40px;
      padding-top: 20px;
      padding-bottom: 40px;
    }
  }
`

export default LogoCarouselComponent
